import { BusinessRegion, BusinessRegionResponseData } from '@city/const';
import { GeoPoint } from '@core/const';
import { StateUtils } from '@spartacus/core';
import { BUSINESS_REGION, CURRENT_POINT_BUSINESS_REGION } from '../city-state';

export const LOAD_BUSINESS_REGION_FROM_COORDS = '[CUSTOM CITY] load business region from coords';
export const LOAD_BUSINESS_REGION_FROM_COORDS_SUCCESS = '[CUSTOM CITY] load business region from coords SUCCESS';
export const LOAD_BUSINESS_REGION_FROM_COORDS_FAIL = '[CUSTOM CITY] load business region from coords FAIL';

export const LOAD_BUSINESS_REGION = '[City] BusinessRegion Load';
export const LOAD_BUSINESS_REGION_SUCCESS = '[City] BusinessRegion Load Success';
export const LOAD_BUSINESS_REGION_FAIL = '[City] BusinessRegion Load Fail';
export const BUSINESS_REGION_RESET = '[City] BusinessRegion Reset';
export const BUSINESS_REGION_RESTORE = '[City] BusinessRegion Restore';

export class LoadBusinessRegionFromCoords extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BUSINESS_REGION_FROM_COORDS;

  constructor(public geoPoint: GeoPoint) {
    super(CURRENT_POINT_BUSINESS_REGION);
  }
}

export class LoadBusinessRegionFromCoordsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BUSINESS_REGION_FROM_COORDS_FAIL;

  constructor(public payload: any) {
    super(CURRENT_POINT_BUSINESS_REGION, payload);
  }
}

export class LoadBusinessRegionFromCoordsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BUSINESS_REGION_FROM_COORDS_SUCCESS;

  constructor(public payload: BusinessRegionResponseData) {
    super(CURRENT_POINT_BUSINESS_REGION);
  }
}

export class BusinessRegionLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BUSINESS_REGION;

  constructor(public geoPoint: GeoPoint) {
    super(BUSINESS_REGION);
  }
}

export class BusinessRegionLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BUSINESS_REGION_FAIL;

  constructor(public payload: any) {
    super(BUSINESS_REGION, payload);
  }
}

export class BusinessRegionLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BUSINESS_REGION_SUCCESS;

  constructor(public payload: BusinessRegion) {
    super(BUSINESS_REGION);
  }
}

// ссанина ебаная
export class BusinessRegionRestore extends StateUtils.LoaderSuccessAction {
  readonly type = BUSINESS_REGION_RESTORE;

  constructor(public payload: BusinessRegion) {
    super(BUSINESS_REGION);
  }
}

export class BusinessRegionReset extends StateUtils.LoaderResetAction {
  readonly type = BUSINESS_REGION_RESET;

  constructor() {
    super(BUSINESS_REGION);
  }
}

export type BusinessRegionLoadAction = BusinessRegionLoad | BusinessRegionLoadFail | BusinessRegionLoadSuccess;
